import { Controller } from "@hotwired/stimulus"
import { Fancybox } from "@fancyapps/ui";

// Connects to data-controller="fancybox"
export default class extends Controller {
  connect() {
    console.log("FancyBox controller connected");
    
    // Basic configuration
    Fancybox.bind("[data-fancybox]", {
      // Automatic type detection
      type: "auto"
    });
  }

  open(event) {
    event.preventDefault();
    const url = event.currentTarget.getAttribute('href');
    const type = event.currentTarget.dataset.type || 'auto';
    
    console.log("Opening FancyBox with URL:", url, "type:", type);
    
    Fancybox.show(
      [
        {
          src: url,
          type: type
        }
      ],
      {
        // Minimális beállítások
        type: "auto"
      }
    );
  }
}
